import type { TranslationKey } from '@/i18n/translation-key';
import {
  ORGANIZATION_BASIC_ROLES,
  ORGANIZATION_ROLES,
  type OrganizationRole,
} from '@/enums/organization-roles.enum.ts';

export function organizationBasicRoleLabel(basic: string, t: (key: TranslationKey) => string): string {
  switch (basic) {
    case ORGANIZATION_BASIC_ROLES.MEMBER:
      return t('organization.team.roleLabels.member');
    case ORGANIZATION_BASIC_ROLES.NETWORK:
      return t('organization.team.basicRoleLabels.network');
    default:
      return basic;
  }
}

export function organizationRoleLabel(role: OrganizationRole, t: (key: TranslationKey) => string): string {
  switch (role) {
    case ORGANIZATION_ROLES.OWNER:
      return t('organization.team.roleLabels.owner');
    case ORGANIZATION_ROLES.ADMIN:
      return t('organization.team.roleLabels.admin');
    case ORGANIZATION_ROLES.PROCUREMENT:
      return t('organization.team.roleLabels.procurement');
    case ORGANIZATION_ROLES.MEMBER:
      return t('organization.team.roleLabels.member');
    case ORGANIZATION_ROLES.CONTENT_MANAGER:
      return t('organization.team.roleLabels.content_manager');
    case ORGANIZATION_ROLES.EVENT_PLANNER:
      return t('organization.team.roleLabels.event_planner');
    case ORGANIZATION_ROLES.EVENT_ORGANIZER:
      return t('organization.team.roleLabels.event_organizer');
    default:
      return role;
  }
}
